/**
 * Sleeves Collection Slider
 * Manages tabs, sliders, and color dots for each tab
 */
(function() {
	'use strict';

	class SleevesCollection {
		constructor(container) {
			this.container = container;
			this.tabs = container.querySelectorAll('.sleeves-collection--tab');
			this.tabPanels = container.querySelectorAll('.sleeves-collection--tab-panel');
			this.sliders = {};
			
			this.init();
		}

		init() {
			// Setup tab switching first
			this.setupTabs();
			
			// Initialize each tab panel
			this.tabPanels.forEach((panel, index) => {
				const tabIndex = panel.dataset.tabIndex;
				this.initSlider(panel, tabIndex);
			});

			// Trigger lazy loading for visible images
			if (typeof lazySizes !== 'undefined') {
				lazySizes.init();
			}
		}

		initSlider(panel, tabIndex) {
			const slider = panel.querySelector('.sleeves-collection--slider');
			const slides = panel.querySelectorAll('.sleeves-collection--slide');
			const prevBtn = panel.querySelector('.sleeves-collection--arrow-prev');
			const nextBtn = panel.querySelector('.sleeves-collection--arrow-next');
			const colorDots = panel.querySelectorAll('.sleeves-collection--color-dot');

			if (!slider) {
				console.warn('Slider not found for tab', tabIndex);
				return;
			}
			
			if (slides.length === 0) {
				console.warn('No slides found for tab', tabIndex);
				return;
			}

			console.log(`Initializing slider for tab ${tabIndex} with ${slides.length} slides`);

			let currentIndex = 0;
			const totalSlides = slides.length;

			const updateSlider = () => {
				// Hide all slides
				slides.forEach((slide, index) => {
					slide.classList.remove('active');
					if (index === currentIndex) {
						slide.classList.add('active');
					}
				});

				// Move slider track
				const track = slider.querySelector('.sleeves-collection--slider-track');
				if (track) {
					const translateX = -currentIndex * 100;
					track.style.transform = `translateX(${translateX}%)`;
				}

				// Update color dots
				colorDots.forEach((dot, index) => {
					dot.classList.toggle('active', index === currentIndex);
				});

				// Update arrow states
				if (prevBtn) {
					prevBtn.disabled = currentIndex === 0;
					prevBtn.style.opacity = currentIndex === 0 ? '0.5' : '1';
				}
				if (nextBtn) {
					nextBtn.disabled = currentIndex === totalSlides - 1;
					nextBtn.style.opacity = currentIndex === totalSlides - 1 ? '0.5' : '1';
				}
			};

			const goToSlide = (index) => {
				if (index < 0 || index >= totalSlides) return;
				currentIndex = index;
				updateSlider();
			};

			const nextSlide = () => {
				if (currentIndex < totalSlides - 1) {
					goToSlide(currentIndex + 1);
				}
			};

			const prevSlide = () => {
				if (currentIndex > 0) {
					goToSlide(currentIndex - 1);
				}
			};

			// Event listeners
			if (prevBtn) {
				prevBtn.addEventListener('click', prevSlide);
			}
			if (nextBtn) {
				nextBtn.addEventListener('click', nextSlide);
			}

			// Color dot click handlers
			colorDots.forEach((dot, index) => {
				dot.addEventListener('click', () => {
					goToSlide(index);
				});
			});

			// Store slider state
			this.sliders[tabIndex] = {
				currentIndex,
				totalSlides,
				goToSlide,
				nextSlide,
				prevSlide,
				updateSlider
			};

			// Initialize - set initial transform
			const track = slider.querySelector('.sleeves-collection--slider-track');
			if (track) {
				track.style.transform = 'translateX(0%)';
			}
			
			// Initialize
			updateSlider();
		}

		setupTabs() {
			this.tabs.forEach((tab) => {
				tab.addEventListener('click', () => {
					const tabIndex = tab.dataset.tabIndex;
					this.switchTab(tabIndex);
				});
			});
		}

		switchTab(tabIndex) {
			// Update tab buttons
			this.tabs.forEach((tab) => {
				const isActive = tab.dataset.tabIndex === tabIndex;
				tab.classList.toggle('active', isActive);
				tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
			});

			// Update tab panels
			this.tabPanels.forEach((panel) => {
				const isActive = panel.dataset.tabIndex === tabIndex;
				panel.classList.toggle('active', isActive);
				
				// Re-initialize slider if needed and trigger lazy loading
				if (isActive && typeof lazySizes !== 'undefined') {
					setTimeout(() => {
						lazySizes.init();
					}, 100);
				}
			});
		}
	}

	// Initialize all sleeves collection sections
	document.addEventListener('DOMContentLoaded', () => {
		const sections = document.querySelectorAll('.sleeves-collection');
		sections.forEach(section => {
			new SleevesCollection(section);
		});
	});

	// Re-initialize on section load (for Shopify theme editor)
	if (Shopify && Shopify.designMode) {
		document.addEventListener('shopify:section:load', (event) => {
			const section = event.detail.querySelector('.sleeves-collection');
			if (section) {
				new SleevesCollection(section);
			}
		});
	}
})();
